// extracted by mini-css-extract-plugin
export default {"container":"Kde4mU","listItem":"TiQb0B","numberElementWithIcon":"Gm1fc2","icon":"HH12GW","defaultCursor":"itC799","emotionsIcon":"BbFUqs"};